<script>
import {
    fade
} from 'svelte/transition';
import {
    modalState, hideModal
} from '@app/store/modalStore.svelte.js';
import {
    speakerState
} from '@app/store/speakerStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import {
    v4 as uuidv4
} from 'uuid';
import Swal from 'sweetalert2';
import { SWAL_BASE, SWAL_CLASSES } from "@app/lib/swalClasses.js";
import { toast } from '@zerodevx/svelte-toast';
import colorDict from "@cclib/dict/colors.js";
import * as m from "@app/paraglide/messages.js";

let speakerName = $state(""), speakerColour = $state(colorDict.speakerOrder[0]), mergeSpeakerOpt = $state(), selected = $state();
function addSpeaker() {
    if (!speakerName){
        return;
    }

    speakerState.push({
        id: uuidv4(),
        name: speakerName,
        colour: speakerColour,
    });

    clear();

    insertHistoryAction({
        name: "add speaker", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "speakerState",
            value: JSON.stringify(speakerState)
        }]
    });
}

function editSpeaker(speaker){
    selected = speaker;
    speakerName = speaker.name;
    speakerColour = speaker.colour
}

function updateSpeaker(){
    try {
        let index = speakerState.findIndex(sp =>{
            return sp.id === selected.id;
        });

        insertHistoryAction({
            name: "update speakers", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "speakerState",
                value: JSON.stringify(speakerState)
            }]
        });

        if (mergeSpeakerOpt){
            //ask the user if they want to merge the speakers using sweetalert
            let mergedSpeakerIndex = speakerState.findIndex(sp => sp.id === mergeSpeakerOpt);            
            if (mergedSpeakerIndex > -1 && index > -1 && selected.id !== mergeSpeakerOpt){
                // console.log("Merge speaker", mergedSpeakerIndex, "with speaker", index);
                Swal.fire({
                    ...SWAL_BASE,
                    customClass: SWAL_CLASSES.confirmCancel,
                    title: m.speaker_manager_merge_title(),
                    text: m.speaker_manager_merge_text({
                        selected: selected.name,
                        primary: speakerState[mergedSpeakerIndex].name
                    }),
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: m.speaker_manager_merge_confirm(),
                    cancelButtonText: m.speaker_manager_merge_cancel(),
                }).then((result) => {
                    if (result.isConfirmed) {
                        eventGroupState.forEach(eventGroup=>{
                            eventGroup.events.forEach((event, i, events) =>{
                                events[i].speakers.forEach((sp, c, s) =>{
                                    if (sp.id === selected.id || sp.name === selected.name){
                                        events[i].speakers[c] = speakerState[mergedSpeakerIndex];
                                    }
                                });

                                //Ensure that all speakers assigned to the Event are unique
                                events[i].speakers = events[i].speakers.filter((value, index, self) =>
                                    index === self.findIndex((t) => (
                                        t.id === value.id || t.name === value.name
                                    ))
                                );                                                          
                            });
                        });

                        
                        removeSpeaker(selected);

                        insertHistoryAction({
                            name: "update speakers", //action name
                            eventGroup: projectState.selected,
                            snapshots: [{
                                store: "eventGroupState",
                                value: JSON.stringify(eventGroupState)
                            }]
                        });

                        insertHistoryAction({
                            name: "update speakers", //action name
                            eventGroup: projectState.selected,
                            snapshots: [{
                                store: "speakerState",
                                value: JSON.stringify(speakerState)
                            }]
                        });
                    }
                }).finally(()=>{
                    clear();
                });
            } else {
                toast.push(m.speaker_manager_merge_failed_toast(), {classes: ['toast-warning']});
                clear();
            }       
        } else if (index > -1 && speakerName){      
            speakerState[index].name = speakerName;
            speakerState[index].colour = speakerColour;
            /* Update Event Speakers */
            eventGroupState.forEach(eventGroup=>{
                eventGroup.events.forEach((event, i, events) =>{
                    events[i].speakers.forEach((sp, c, s) =>{
                        if (sp.id === speakerState[index].id){
                            s[c].name = speakerState[index].name;
                            s[c].colour = speakerState[index].colour;
                        }
                    });
                })
            });

            
            insertHistoryAction({
                name: "update speakers", //action name
                eventGroup: projectState.selected,
                snapshots: [{
                    store: "speakerState",
                    value: JSON.stringify(speakerState)
                }]
            });

            insertHistoryAction({
                name: "update speakers", //action name
                eventGroup: projectState.selected,
                snapshots: [{
                    store: "eventGroupState",
                    value: JSON.stringify(eventGroupState)
                }]
            });

            clear();
        }
    } catch (err){
        console.error(err);
        toast.push(m.speaker_manager_update_failed_toast(), {classes: ['toast-warning']});
    }
}

function removeSpeaker(speaker){
    // console.log("REMOVING SPEAKER: "+speaker.name);
    const filteredSpeakers = speakerState.filter(sp =>{
        return sp.id !== speaker.id;
    });
    
    // Clear the array and add all filtered items back
    speakerState.length = 0;
    filteredSpeakers.forEach(sp => speakerState.push(sp));

    /* Update Event Speakers */
    eventGroupState.forEach(eventGroup=>{
        eventGroup.events.forEach((event, i, events) =>{
            events[i].speakers = event.speakers.filter(sp =>{
                return sp.id !== speaker.id;
            });
        });
    });

    

    clear()

    insertHistoryAction({
        name: "remove speaker", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "speakerState",
            value: JSON.stringify(speakerState)
        }]
    });
}

function clear(){
    speakerName = "";
    speakerColour = colorDict.speakerOrder[speakerState.length % colorDict.speakerOrder.length];
    selected = undefined;
    mergeSpeakerOpt = undefined;
}

function submitForm(){
    if(!selected) {
        addSpeaker()
    } else {
        updateSpeaker()
    }
}

function handleFormSubmit(e) {
    e.preventDefault();
    submitForm();
}
</script>

<div 
    transition:fade={{ duration: 100 }}
    class="modal {modalState.selected === 'speakerManager' ? 'show d-block' : ''}"
    role="dialog"
    aria-modal="true"
    aria-labelledby="speakerManagerTitle"
    tabindex="-1"
>
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="speakerManagerTitle">{m.speaker_manager_title()}</h4>
                <button 
                    type="button"
                    class="btn-close"
                    aria-label={m.speaker_manager_close_aria_label()}
                    onclick={hideModal}
                ></button>
            </div>
            <div class="modal-body">
                <form onsubmit={handleFormSubmit}>
                    <div class="row mb-2">
                        <div class="col-9">
                            <label for="speakerName" class="form-label">{m.speaker_manager_name_label()}</label>
                            <input 
                                type="text"
                                class="form-control"
                                id="speakerName"
                                bind:value={speakerName}
                                aria-required="true"
                            />
                        </div>
                        <div class="col-3">
                            <label for="speakerColor" class="form-label">{m.speaker_manager_color_label()}</label>
                            <select
                                class="form-select"
                                id="speakerColor"
                                bind:value={speakerColour}
                                aria-label={m.speaker_manager_color_aria_label()}
                            >
                                {#each colorDict.speakerOrder as color}
                                    <option value={color}>{color}</option>
                                {/each}
                            </select>
                        </div>
                        {#if selected}
                        <div class="col-9 my-2">
                            <label class="form-label" for="speakerMergeSelect">{m.speaker_manager_merge_with_label()}</label>
                            <select id="speakerMergeSelect" class="form-select" bind:value={mergeSpeakerOpt}>
                                <option value="">{m.speaker_manager_merge_select_placeholder()}</option>
                                {#each speakerState as speaker}
                                <option value={speaker.id}>{speaker.name}</option>
                                {/each}
                            </select>
                        </div>
                        {/if}
                    </div>
                    <div class="mb-3 text-end">
                        <button type="submit" class="btn btn-primary" disabled={!speakerName}>{m.speaker_manager_save_button()}</button>
                        <button type="button" class="btn btn-outline-dark" onclick={clear}>{m.speaker_manager_clear_button()}</button>
                    </div>
                </form>
                <div class="table-responsive">
                <table 
                    class="table table-sm table-striped"
                    aria-label={m.speaker_manager_list_aria_label()}
                >
                    <thead>
                      <tr>
                        <th scope="col">{m.speaker_manager_table_index()}</th>
                        <th scope="col">{m.speaker_manager_table_name()}</th>
                        <th scope="col">{m.speaker_manager_table_color()}</th>
                        <th style="width:125px;" scope="col">{m.speaker_manager_table_actions()}</th>
                      </tr>
                    </thead>
                    <tbody>
                        {#each speakerState as speaker, index (speaker.id)}
                        <tr>
                            <td>{index+1}</td>
                            <td>{speaker.name}</td>
                            <td style="background-color: {speaker.colour}"></td>
                            <td class='text-center'>
                                <button class="btn btn-sm btn-info" type="button" title={m.speaker_manager_edit_title()} aria-label={m.speaker_manager_edit_aria_label()} onclick={() => editSpeaker(speaker)}><i class="bi bi-pencil-square"></i></button>
                                <button class="btn btn-sm btn-danger" type="button" title={m.speaker_manager_remove_title()} aria-label={m.speaker_manager_remove_aria_label()} onclick={() => removeSpeaker(speaker)}><i class="bi bi-trash"></i></button>
                            </td>                            
                        </tr>
                        {/each}
                    </tbody>
                  </table>
                </div>
            </div>
        </div>
    </div>
</div>

<style lang="css">
    .table-responsive {
        max-height: 500px;
        overflow: scroll;
    }
</style>
